import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class SoundOnIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 22 22" fill="none">
            <g clip-path="url(#clip0_10425_165891)">
                <g filter="url(#filter0_d_10425_165891)">
                    <path d="M6.36246 15.3301H3.50485C2.58266 15.3301 1.83496 14.5824 1.83496 13.6602V8.34665C1.83496 7.42445 2.58266 6.67676 3.50485 6.67676H6.36246V15.3301Z" stroke="white" stroke-width="1.66989" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.36255 15.3296L13.6533 21.168V0.837891L6.36255 6.67625V15.3296Z" stroke="white" stroke-width="1.66989" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M19 16.9131C19.8946 15.1338 20.399 13.1262 20.399 11.0025C20.399 8.87884 19.8946 6.87204 19.0004 5.09277" stroke="white" stroke-width="1.66989" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M16.9663 14.5037C17.4001 13.4212 17.6389 12.2393 17.6389 11.0019C17.6389 9.76452 17.4001 8.58348 16.9663 7.50098" stroke="white" stroke-width="1.66989" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </g>
            <defs>
                <filter id="filter0_d_10425_165891" x="-4" y="-4" width="30" height="30.0029" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10425_165891" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10425_165891" result="shape" />
                </filter>
                <clipPath id="clip0_10425_165891">
                    <rect width="22" height="22" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>;
    }
}
